import { axiosInstance } from "./axios";
import { queryOptions } from "@tanstack/react-query";

export interface PlayerFeedbackResponse {
    id: number;
    playerId: number;
    tournamentId: number;
    teamId: number;
    feedback: string;
    model: string;
    tokensUsed: number;
    createdAt: string;
    updatedAt?: string;
    wasGenerated: boolean;
}

export interface GeneratePlayerFeedbackRequest {
    playerId: number;
    tournamentId: number;
    teamId: number;
}

export const playerFeedbackApi = {
    // Generate a new player feedback
    generateFeedback: async (playerId: number, tournamentId: number, teamId: number): Promise<PlayerFeedbackResponse> => {
        const response = await axiosInstance.post<PlayerFeedbackResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/feedback`
        );
        return response.data;
    },

    // Regenerate existing player feedback
    regenerateFeedback: async (playerId: number, tournamentId: number, teamId: number): Promise<PlayerFeedbackResponse> => {
        const response = await axiosInstance.put<PlayerFeedbackResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/feedback/regenerate`
        );
        return response.data;
    },

    // Get existing player feedback
    getFeedback: async (playerId: number, tournamentId: number, teamId: number, forceRegenerate: boolean = false): Promise<PlayerFeedbackResponse> => {
        const response = await axiosInstance.get<PlayerFeedbackResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/feedback?forceRegenerate=${forceRegenerate}`
        );
        return response.data;
    },
};

export const playerFeedbackQueryOptions = (playerId: number, tournamentId: number, teamId: number) =>
    queryOptions({
        queryKey: ["player-feedback", playerId, tournamentId, teamId],
        queryFn: () => playerFeedbackApi.generateFeedback(playerId, tournamentId, teamId),
        staleTime: 5 * 60 * 1000,
    });
